import { targetTypeConstants } from "../_constants";

export const replaceTargetString = (key, t) => {
  switch (key) {
    case targetTypeConstants.SERIAL_NUMBER:
      return t("common:columns.serial");
    case targetTypeConstants.REGIONAL:
      return t("common:columns.country");
    case targetTypeConstants.VIRTUAL:
      return t("common:columns.virtual");
    case targetTypeConstants.PHYSICAL:
      return t("common:columns.physical");
    case targetTypeConstants.VERSION:
      return t("common:columns.version");
    default:
      return key;
  }
};
